import { call, put, select } from "redux-saga/effects";
import { setCookie } from "../../../utils/cookies";

// Api
import { foreignProfilebrandInfo, switchableProfile } from "../../../api";

// Actions
import { profileActions } from "../../../actions/profile";
import { authActions } from "../../../actions/auth";

export function* getProfileData({ payload: { slug, history, callback } }) {
  try {
    const res = yield call(foreignProfilebrandInfo, slug);
    if (res?.response) {
      yield put(profileActions.setProfileData(res.response));
      if (callback) yield call(callback, res.response.is_following);
    } else {
      yield put(profileActions.setProfileError("PAGE_NOT_ACTIVE"));
    }
  } catch (error) {
    yield put(profileActions.setProfileError("PAGE_NOT_ACTIVE"));
  }
}

export function* fetchProfilesForSwitchPopup({ payload: { history } }) {
  const { response } = yield call(switchableProfile);
  if (response) {
    yield put(profileActions.setProfilesToSwitchPopup(response.profilebrands));
  } else {
    yield call([history, "push"], "/enter");
  }
}

export function* switchProfileThroughSwitchPopup({
  payload: { slug, id, history, cb },
}) {
  yield call([localStorage, "setItem"], "client_id", id);
  const { response } = yield call(foreignProfilebrandInfo, slug);
  if (response) {
    const { wardrobeProducts } = yield select((state) => state.profileReducer);
    if (wardrobeProducts) {
      yield put(profileActions.fetchWardrobeSucceeded(null));
    }
    yield put(profileActions.setProfileData(response));
    yield put(profileActions.updateSwitchableProfileStatus(slug));
    yield put(profileActions.resetTabSelectionState());
    yield put(authActions.updateProfileInfoSucceeded(response));
    yield call(
      [localStorage, "setItem"],
      "user_info",
      JSON.stringify(response)
    );
    yield call(setCookie, "user_info", encodeURIComponent(JSON.stringify(response)), 30);
    if (cb) {
      yield call(cb, response);
    }
  } else if (history) {
    yield call([history, "push"], "/enter");
  }
}

export function* switchProfileWhenLogin({
  payload: { slug, id, history, cb },
}) {
  yield call([localStorage, "setItem"], "client_id", id);
  const { response } = yield call(foreignProfilebrandInfo, slug);
  if (response) {
    yield put(profileActions.updateSwitchableProfileStatus(slug));
    yield put(profileActions.resetTabSelectionState());
    yield put(authActions.updateProfileInfoSucceeded(response));
    yield call(
      [localStorage, "setItem"],
      "user_info",
      JSON.stringify(response)
    );
    yield call(setCookie, "user_info", encodeURIComponent(JSON.stringify(response)), 30);
    if (cb) {
      yield call(cb, response);
    }
  } else if (history) {
    yield call([history, "push"], "/enter");
  }
}
